import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MakerCheckerComponent } from './maker-checker/maker-checker.component';
import { AuthService } from '../services/auth.service';

const routes: Routes = [
  { path: 'maker-checker/:tag', component: MakerCheckerComponent, canActivate: [AuthService] },
  { path: 'maker-checker', title: 'XBC-Review requests', component: MakerCheckerComponent, canActivate: [AuthService] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class XBCCommonRoutingModule { }
